export const SPOTLIGHT_FORM_FACTOR_GATE = 'LiveChat:SpotlightFormFactor';
export const SPOTLIGHT_POSITION_GATE = 'LiveChat:SpotlightPosition';